<template>
  <div class="pvd-form-row">
    <div class="form-row-label">
      <label
        :for="idPrefix"
      >
        {{ dropdownLabel }}
      </label>
    </div>
    <div class="form-row-content">
      <select
        :id="idPrefix"
        :key="name"
        v-model="mutableDropdownValue"
        v-validate="parsedRules"
        :class="['pvd-select', {'input-error': errors.has(name)}]"
        :name="name"
        :aria-invalid="errors.has(name) ? true: null"
        :aria-describedby="errors.has(name) ? `${idPrefix}Error` : null"
      >
        <option
          v-for="option in optionList"
          :key="option.value"
          :value="option.value"
        >
          {{ option.option }}
        </option>
      </select>
    </div>
    <InlineMessage
      v-show="errors.has(name)"
      :id-prefix="idPrefix"
      :message="message"
    />
  </div>
</template>

<script>
import InlineMessage from './InlineMessage.vue';
import utilityFunctions from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';

export default {
  name: 'DropdownComponent',
  components: { InlineMessage },
  mixins: [utilityFunctions, validationHelper],
  inject: ['$validator'],
  $_veeValidate: {
    value() {
      return this.mutableDropdownValue;
    },
    name() {
      return this.name;
    },
  },
  props: {
    dropdownLabel: {
      type: String,
      default: '',
    },
    dropdownValue: {
      type: String,
      default: '',
    },
    optionList: {
      type: Array,
      default: () => [],
    },
    idPrefix: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    validationRules: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    mutableDropdownValue: {
      get() {
        return this.dropdownValue;
      },
      set(newValue) {
        this.$emit('update:dropdownValue', newValue);
      },
    },
    parsedRules() {
      let rules = {};
      if (this.validationRules) {
        rules = this.parseRules(this.validationRules);
      }
      return rules;
    },
  },
};
</script>

<style scoped>

</style>
